import { render, staticRenderFns } from "./SpecialCard2.vue?vue&type=template&id=06e74051&"
import script from "./SpecialCard2.vue?vue&type=script&lang=ts&"
export * from "./SpecialCard2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports